export const AI_SUGGESTIONS = [
    { value: "si.super-agent.ai-suggestions.value.1", label: "si.super-agent.ai-suggestions.1" },
    { value: "si.super-agent.ai-suggestions.value.2", label: "si.super-agent.ai-suggestions.2" },
    { value: "si.super-agent.ai-suggestions.value.3", label: "si.super-agent.ai-suggestions.3" },
];

export const EXTENDED_AI_SUGGESTIONS = [
    ...AI_SUGGESTIONS,
    { value: "si.super-agent.ai-suggestions.value.4", label: "si.super-agent.ai-suggestions.4" },
];

export const MAX_RECENTS_AI_SUGGESTIONS_TO_SHOW = 3;
export const MAX_RESULTS_QUOTA_REACHED = 4;
export const MAX_RESULTS = 8;
